import { baseCRUDAPI } from './base';

export default class FleetSize extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'FleetSize');
  }
}
